import { render } from "./designOcrPreview.vue?vue&type=template&id=2b8faa26"
import script from "./designOcrPreview.vue?vue&type=script&lang=js"
export * from "./designOcrPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__